
import Clarity from "@microsoft/clarity";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import Form from "./form/Form";

export default function ProfileEdit() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const [profile, setProfile] = useState(null);
	const [errorMessage, setErrorMessage] = useState("");
	const profileId = LoginHelper.getProfileId();
	const linkDataList = [
		{ label: "خانه", href: "/" },
		...(profileId
			? [{ label: "پروفایل", href: "/profile/" + profileId + "/" }]
			: []),
		{ label: "ویرایش", href: "/profile_edit/" },
	];

	useEffect(() => {
		fetchProfile();
	}, []);

	function fetchProfile() {
		api.profileFetchEdit({
			token: LoginHelper.getToken(),
		})
			.then((result) => {
				setProfile(result);
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	const column = "mx-auto w-full max-w-[560px] px-4";

	return (
		<>
			<Helmet>
				<title>ویرایش پروفایل | همراهتیم</title>
				<meta name="description" content="ویرایش پروفایل همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white border-b border-[#E2E8F0]">
						<div className={column}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className={`${column} py-6 sm:py-8`}>
						{profile ? <Form profile={profile} /> : null}
						{!profile && errorMessage ? (
							<p className="text-center font-Vazir-400 text-[14px] text-error mt-4">
								{errorMessage}
							</p>
						) : null}
					</div>
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
